// One file's diff as a table of its rows: the Changes pane's, and a ready proposal's card on the Board (Poulpe-155).
import { memo } from 'react'
import type { DiffRow } from './diff'
import './diffRows.css'

export const DiffRows = memo(function DiffRows({ rows, label }: { rows: readonly DiffRow[]; label: string }) {
  return (
    <table className="changes-diff-table" aria-label={label}>
      <tbody>
        {rows.map((row, i) =>
          row.kind === 'hunk' || row.kind === 'note' ? (
            <tr key={i} className={`is-${row.kind}`}>
              <td colSpan={4}>{row.text}</td>
            </tr>
          ) : (
            <tr key={i} className={`is-${row.kind}`}>
              <td className="changes-diff-number">{row.kind === 'add' ? '' : row.old}</td>
              <td className="changes-diff-number">{row.kind === 'del' ? '' : row.new}</td>
              <td className="changes-diff-sign">{row.kind === 'add' ? '+' : row.kind === 'del' ? '-' : ''}</td>
              <td className="changes-diff-text">{row.text}</td>
            </tr>
          ),
        )}
      </tbody>
    </table>
  )
})
